import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {WIZARD_WIDGET} from "../../../widgets/wizard-widget/wizard-widget-consts";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";

export class WizardImportSelectionClickEvent extends ClickEvent {
  source: WIZARD_WIDGET.IMPORT_SELECTIONS.SOURCES;

  constructor(params) {
    super('', 'click', 'selections-import');

    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();

    return new GoogleAnalyticsEventModel(eventName, {
      source: this.source,
    })
  }
}